import styled from 'styled-components';
import BlueRewardsLogo from './BlueRewardsLogo';
import { attachLocale } from '../../../../lib/utils';
import { trackAnalyticsNew } from '../../../../lib/trackAnalyticsNew';
import { DATA_TRACK_TYPE_INTERNAL } from '../../../../lib/constants';
import type { Locale } from '../../../../lib/locale';
import type { NavigationLogoSlotFieldsFragment } from '../../../../graphql/fragments/navigation-global.generated';

type ShopsLogoContainerProps = {
  shopsLogoNavSlot?: Partial<Pick<NavigationLogoSlotFieldsFragment, 'text' | 'url'>>;
  location?: string;
  size?: 'regular' | 'large';
  locale?: Locale;
};

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const ShopsLink = styled.a`
  display: inline-flex;
  text-decoration: none;
`;

const ShopsLogoContainer = (props: ShopsLogoContainerProps) => {
  const {
    shopsLogoNavSlot = {},
    location = 'page',
    size,
    locale,
  } = props;

  const localizedUrl = attachLocale(shopsLogoNavSlot.url ?? '', locale);
  const trackShops = trackAnalyticsNew({
    url: localizedUrl,
    location,
    name: 'blue-rewards-logo',
  });

  return (
    <LogoContainer>
      {shopsLogoNavSlot.url ? (
        <ShopsLink
          id={trackShops.dataTrackingId}
          data-track-id={trackShops.dataTrackingId}
          data-track-click={trackShops.dataTrack}
          data-track-type={DATA_TRACK_TYPE_INTERNAL}
          href={trackShops.url}
        >
          <BlueRewardsLogo text={shopsLogoNavSlot.text} size={size} locale={locale} />
        </ShopsLink>
      ) : (
        <BlueRewardsLogo text={shopsLogoNavSlot.text} size={size} locale={locale} />
      )}
    </LogoContainer>
  );
};

export default ShopsLogoContainer;
